import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import ScreenReaderPrefix from "../ScreenReaderPrefix.js";
import styles from "../../css/index.css";
var Alert = function Alert(props) {
  var children = props.children,
    type = props.type,
    position = props.position,
    visible = props.visible,
    classesProp = props.classes,
    id = props.id;
  var classes = useClasses(styles, classesProp);
  var typeClassMap = {
    error: classes['type-error'],
    info: classes['type-info']
  };
  var positionClassMap = {
    top: classes['position-top'],
    bottom: classes['position-bottom']
  };
  var baseClass = classes.container || '';
  var visibility = visible ? 'is-visible' : 'is-not-visible';
  var visibleClass = classes[visibility] || '';
  var typeClass = typeClassMap[type] || '';
  var positionClass = positionClassMap[position] || '';
  var role = visible ? 'alert' : 'none';
  var live = visible ? 'polite' : 'off';
  var ariaHidden = !visible;
  return /*#__PURE__*/React.createElement("div", {
    role: role,
    "aria-live": live,
    "aria-hidden": ariaHidden,
    id: id,
    className: "".concat(baseClass, " ").concat(typeClass, " ").concat(positionClass, " ").concat(visibleClass)
  }, /*#__PURE__*/React.createElement(ScreenReaderPrefix, {
    type: type
  }), children);
};
Alert.defaultProps = {
  position: 'top',
  type: 'error'
};
process.env.NODE_ENV !== "production" ? Alert.propTypes = {
  /**
   * Contents of alert
   */
  children: PropTypes.node,
  /**
   * Type of alert (Currently, error and info are the only supported types)
   */
  type: PropTypes.oneOf(['error', 'info']),
  /**
   * Position in container
   */
  position: PropTypes.oneOf(['top', 'bottom']),
  /**
   * Should the alert be visible
   */
  visible: PropTypes.bool,
  /**
   * Class dependencies
   */
  classes: classesPropType(['container', 'is-visible', 'is-not-visible', 'type-error', 'type-info', 'position-top', 'position-bottom']),
  /**
   * ID of the alert component
   */
  id: PropTypes.string
} : void 0;
export default Alert;